import * as ContextMenu from "@radix-ui/react-context-menu";
import { IconCopy, IconFolderOpen, IconPencil, IconTransfer, IconTrash } from "@tabler/icons-react";

import { useFileManager } from "@/components/core/FileManager";
import { useFileManagerUI } from "@/components/core/FileManager";
import type { FileManagerItem } from "@/components/core/FileManager";

import styles from "./FileManagerContextMenu.module.scss";

interface FileManagerTreeItemMenuItemsProps {
  item: FileManagerItem;
}

export function FileManagerTreeItemMenuItems({ item }: FileManagerTreeItemMenuItemsProps) {
  const { openFolder, permissions, isLocked } = useFileManager();
  const { openRename, openMove, openDuplicate, openDelete } = useFileManagerUI();

  return (
    <>
      <ContextMenu.Item className={styles.item} onSelect={() => openFolder(item.id, item.name)}>
        <IconFolderOpen size={16} />
        Open
      </ContextMenu.Item>

      {permissions.canEdit && !isLocked(item, "rename") && (
        <>
          <ContextMenu.Separator className={styles.separator} />
          <ContextMenu.Item
            className={styles.item}
            onSelect={() => openRename({ type: item.type, id: item.id, name: item.name })}
          >
            <IconPencil size={16} />
            Rename
          </ContextMenu.Item>
        </>
      )}

      {permissions.canEdit && !isLocked(item, "move") && (
        <ContextMenu.Item
          className={styles.item}
          onSelect={() => openMove({ type: item.type, id: item.id, name: item.name })}
        >
          <IconTransfer size={16} />
          Move to...
        </ContextMenu.Item>
      )}

      {permissions.canEdit && (
        <ContextMenu.Item
          className={styles.item}
          onSelect={() => openDuplicate({ type: item.type, id: item.id, name: item.name })}
        >
          <IconCopy size={16} />
          Copy folder
        </ContextMenu.Item>
      )}

      {permissions.canDelete && !isLocked(item, "delete") && (
        <>
          <ContextMenu.Separator className={styles.separator} />
          <ContextMenu.Item
            className={styles.destructiveItem}
            onSelect={() =>
              openDelete({
                items: [{ type: item.type, id: item.id, name: item.name, s3Key: item.s3Key }],
              })
            }
          >
            <IconTrash size={16} />
            Delete
          </ContextMenu.Item>
        </>
      )}
    </>
  );
}
